module.exports = __webpack_public_path__ + "202222:4f4eb5d45eb7a9e97a70/img/big_image@2x.a17ee50.jpg";